import { defineRoutes } from '../utils';

/**
 * Fleet tab kinds — kept inline (rather than imported from `@hero/web-components`)
 * so the navigation layer stays foundational and the route registry can be
 * imported anywhere without dragging the component bundle along.
 */
export type FleetTabName = 'vehicles' | 'drivers';

/**
 * Fleet domain routes — carrier-only. Mounts the shared
 * `<FleetPage />` from `@hero/web-components` at `/fleet`. The
 * page hosts both vehicles and drivers behind a `?tab=` switch
 * so the URL stays stable across the two sub-views.
 */
export const fleetRoutes = defineRoutes({
  fleet: {
    path: '/fleet',
    isPublic: false,
    params: {} as {
      /** Active tab (`'vehicles'` is the default and is omitted from the URL). */
      tab?: FleetTabName;
    },
  },
});
